import React from 'react';
import Hero from '../components/Hero';
import Content from '../components/Content';

function AboutPage(props) {
    return(
        <div>
            <Hero title={props.title} />

            <Content>
                <p>My name is Manov Jain, I am a senior at Southern Methodist University. I am double majoring in Computer Science, Bachelors of Science and Film & Media Arts, Bachelors of Art.</p>

                <p>I created this website to showcase some of my projects and my coding ability. It was created using react and is being hosted on firebase. I hope you will take the time to explore the site and learn about me!</p>

                <p>Below are some links to my work!</p>

                <a href="https://github.com/ManovJain">Check out my Github!</a>

                <p></p>


                <a href="https://www.youtube.com/watch?v=BF4P2GhHJeU&t=4311s">Learn more about ANIM. </a>
                <p>This is a business I created and recieved seed funding for! To view my pitch skip to 1:12:14</p>
            </Content>
        </div>
    );
    
}

export default AboutPage;